import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { ContentWrapper } from "../../components/ContentWrapper";
import { GroupsTable } from "./GroupsTable";
import { useQuery } from "@tanstack/react-query";
import { findGroups } from "../../database/queries/queries";
import { Loading } from "../../components/Loading";

export function GroupsApp() {
  const { data: groups, isLoading, error } = useQuery({
    queryKey: ["groups"],
    queryFn: findGroups,
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ContentWrapper hasScroll>
      <Box sx={{ p: 4, pb: 8 }}>
        <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
          Avaliar grupos
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Listagem em formato de tabela com virtual scrolling para manter a
          performance mesmo com muitos registros.
        </Typography>

        {error && (
          <Alert severity="warning" sx={{ mb: 3 }}>
            Nao foi possivel carregar grupos do Firebase.
          </Alert>
        )}

        <GroupsTable rows={groups || []} />
      </Box>
    </ContentWrapper>
  );
}

export default GroupsApp;
